export const AliasMap = {
  id: 'ID',
  os: 'OS',
  ip: 'IP',
  sid: 'ID',
  ctr: 'CTR',
  ecpc: 'ECPC',
  ecpm: 'ECPM',
  sum_commission: 'Commission',
  offer: 'Campaign',
  sum_amount: 'Amount',
  sum_payout: 'Payout',
  vat: 'VAT',
  vat_percentage: 'VAT %',
  CreditNote: 'Credit Note',
  offer_sid: 'Campaign ID',
  media_name: 'AdSpace Name',
  publisher_sid: 'Publisher SID',
  publisher_id: 'Publisher ID',
  adspace: 'AdSpace',
  media_sid: 'AdSpace SID',
  media_id: 'AdSpace ID',
  event_id_name: 'Event ID',
  price_segment_name: 'Price Segment',
  publisher_ref1: 'Publisher Ref 1',
  publisher_ref2: 'Publisher Ref 2',
  ip_tracking: 'smart_fingerprint',
  open: 'Open',
  accepted: 'Accepted',
  declined: 'Declined',
  be_invoiced: 'Invoiced',
  paid_in: 'Paid In',
  paid: 'Paid',
  failed: 'Failed',
  lawyer_moving_in: 'Lawyer Moving In',
  bad_debt: 'Bad Debt',
  handed_to_lawyer: 'Handed To Lawyer',
  TRACKING_EVENT: 'Tracking Event',
  RAW_EVENT: 'Raw Event',
  document_paid_at: 'Paid At (UTC)',
  last_status_change_at: 'Last Status Change (UTC)',
  first_offer_manager: 'First Campaign Manager',
  second_offer_manager: 'Second Campaign Manager',
  install_paid: 'Install Count',
  lead_paid: 'Lead Count',
  sale_paid: 'Sale Count',
  'roas': 'ROAS',
};
